import { safeEncodeURIComponent } from '@/helpers/urlTs';
import { DEFAULT_MY_LOCATION_KEYWORD } from '@/hooks/search/useSearch.constants';
import { TabIdentifier } from '../MegaMenu.constants';
import { TabIdentifier as Identifier } from '../MegaMenu.types';

export function getDefaultSEOContentCtaLink(identifier: Identifier) {
  switch (identifier) {
    case TabIdentifier.Hairdresser:
      return `/${safeEncodeURIComponent('Frisör')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Massage:
      return `/${safeEncodeURIComponent('Massage')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Nails:
      return `/${safeEncodeURIComponent('Naglar')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Lashes:
      return `/${safeEncodeURIComponent('Fransar')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Skincare:
      return `/${safeEncodeURIComponent('Hudvård')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Beauty:
      return `/${safeEncodeURIComponent('Skönhet')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;
    case TabIdentifier.Health:
      return `/${safeEncodeURIComponent('Hälsa')}/${safeEncodeURIComponent(DEFAULT_MY_LOCATION_KEYWORD)}`;

    default:
      return '/';
  }
}
